/* eslint-disable import/no-cycle */
import Admin from '@/components/Admin.vue';
import Committee from '@/components/Committee.vue';
import FAQ from '@/components/FAQ.vue';
import Login from '@/components/Login.vue';
import Logout from '@/components/Logout.vue';
import Main from '@/components/Main.vue';

import AuthClient from '@/api/AuthClient';
import store from '@/store';

const routes = [
  {
    path: '/',
    redirect: 'Login',
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    async beforeEnter(to, from, next) {
      const { isAuthorized } = store.getters;
      if (isAuthorized) {
        next({
          name: 'Event',
        });
      } else {
        next();
      }
    },
  },
  {
    path: '/logout',
    name: 'Logout',
    component: Logout,
  },
  {
    path: '/committee',
    name: 'Committee',
    component: Committee,
  },
  {
    path: '/faq',
    name: 'FAQ',
    component: FAQ,
  },
  {
    path: '/:eventId',
    name: 'Event',
    component: Main,
  },
  {
    path: '/:eventId/admin',
    name: 'Admin',
    component: Admin,
  },
  {
    path: '/authorization-code/callback',
    name: 'Authorization Callback',
    async beforeEnter(to, from, next) {
      const oktaCode = to.query.code || '';
      localStorage.setItem('hackathon-code', oktaCode);
      const redirectUri = process.env.VUE_APP_HACKATHON_REDIRECT_URI;
      if (oktaCode !== undefined) {
        console.log('Attempting authentication');
        const authClient = new AuthClient();
        try {
          const results = await authClient.logUserIn(oktaCode, redirectUri);
          store.commit('setUser', results);
          store.commit('setLoggedIn', true);
          next({
            name: 'Event',
          });
        } catch (err) {
          store.commit('setLoggedIn', false);
          console.log(err);
          next({
            name: 'Logout',
          });
        }
      }
      localStorage.removeItem('hackathon-code');
    },
  },
];

export default routes;
